import React from 'react';

const WhatisAccount = () => {
  return (
    <div>
      <h3 style={{ fontSize: "20px", fontWeight: "300", color: "#000000", marginTop: "20px", marginBottom: "10px" }}>
        What is a Gatnix Account?
      </h3>
      <p style={{ fontSize: "16px", lineHeight: "1.6", color: "#4F4F4F" }}>
        A Gatnix account is your personal gateway to all the services and features we offer. With a registered account, you can securely access our platform, manage your preferences, track your activities, and receive updates tailored to your needs. Whether you're managing transactions, accessing resources, or contacting our support team, your account keeps everything organized and accessible in one place.
      </p>
      <h3 style={{ fontSize: "20px", fontWeight: "300", color: "#000000", marginTop: "20px", marginBottom: "10px" }}>
        Need Further Assistance?
      </h3>
      <p style={{ fontSize: "16px", lineHeight: "1.6", color: "#4F4F4F" }}>
        For additional help, contact our 24/7 live support team via live chat on the Gatnix website, or call us at{" "}
        <strong style={{ color: "#000000" }}>+1 (614) 421-7545</strong>.
      </p>
    </div>
  );
};

export default WhatisAccount;
